import { Component, effect, inject, OnDestroy, Renderer2 } from "@angular/core";
import { Event as RouterEvent, NavigationEnd, Router, RouterLink } from "@angular/router";
import { Subject } from "rxjs";
import { PurchaseComponent } from "@shared/src/lib/stripe/purchase/purchase.component";
import { OutsideClickDirective } from "@shared/src/lib/directives/outsideClick";
import { NgClass } from "@angular/common";
import { CentsToDollarsPipe, NavStore, ScreenStore, UserStore } from "@shared/src/public-api";

@Component({
	selector: "jhmc-nav-bar",
	templateUrl: "./nav-bar.component.html",
	styleUrls: ["./nav-bar.component.scss"],
	imports: [
		NgClass,
		RouterLink,
		OutsideClickDirective,
		PurchaseComponent,
		CentsToDollarsPipe
	]
})
export class NavBarComponent implements OnDestroy
{
	public selectedTabName: string = "INBOX";
	public showStripeModal: boolean = false;
	public creditsAvailable: number = 0;
	public name: string = "";
	public username: string = "";
	public userLoggedIn: boolean = false;
	public showCreditsInfo: boolean = false;
	public showSettingsPopover: boolean = false;
	public navIsOpen: boolean = false;
	public shouldShowExitButton: boolean = false;
	public screenSize: string;
	public isMobile: boolean = false;
	public isAttorney: boolean = false;
	public ngDestroyed$: Subject<any> = new Subject();
	readonly userStore = inject(UserStore);
	readonly navStore = inject(NavStore);
	readonly screenStore = inject(ScreenStore);

	public constructor(private router: Router,
		private renderer: Renderer2)
	{
		this.setSelectedTab(this.router.url);

		this.router.events.subscribe((event: RouterEvent) =>
		{
			if (event instanceof NavigationEnd)
			{
				this.setSelectedTab(event.url);
			}
		});

		this.renderer.listen("window", "click", (e: any) =>
		{
			if (!(e.target.id as string).includes("popover"))
			{
				this.showSettingsPopover = false;
			}
		});
		effect(() => {
			this.name = this.userStore.name();
			this.username = this.userStore.username();
			this.userLoggedIn = this.userStore.isLoggedIn();
			this.creditsAvailable = this.userStore.credits();
			this.isAttorney = this.userStore.isAttorney();
		});

		effect(() => {
			this.navIsOpen = this.navStore.isOpen();
		});

		effect(() => {
			this.shouldShowExitButton = this.screenStore.screenWidth() < 1080;
			this.screenSize = this.screenStore.screenSize();
			if (this.screenSize === "MOBILE") {
				this.isMobile = true;
			}
			else {
				this.isMobile = false;
			}
		});
	}

	ngOnDestroy(): void
	{
		this.ngDestroyed$.next(true);
	}

	public closeNavBar(): void
	{
		this.navStore.close();
	}

	public logout(): void
	{
		this.showSettingsPopover = false;
		this.userStore.logout();
	}

	public onBackgroundClick(event: Event): void
	{
		event.stopPropagation();
		this.closeNavBar();
	}

	private setSelectedTab(url: string)
	{
		if (url.includes("inbox"))
		{
			this.selectedTabName = "INBOX";
		}
		else if (url.includes("drafts"))
		{
			this.selectedTabName = "DRAFTS";
		}
		else if (url.includes("sent"))
		{
			this.selectedTabName = "SENT";
		}
		else if (url.includes("photo-album"))
		{
			this.selectedTabName = "PHOTO_ALBUM";
		}
		else if (url.includes("contacts"))
		{
			this.selectedTabName = "CONTACTS";
		}
		else if (url.includes("secure-documents"))
		{
			this.selectedTabName = "DOCUMENTS";
		}
		else
		{
			this.selectedTabName = "INBOX";
		}
		this.closeNavBar();
	}

	public buyCreditsFromInfoButton(): void
	{
		this.showStripeModal = true;
		this.showCreditsInfo = false;
	}

	public openCreditsInfo(): void
	{
		setTimeout(() =>
		{
			this.showCreditsInfo = true;
		});
	}
}
